var get       = require("object-path").get,
    themeVars = require("app/theme/variables");

module.exports = {

    /**
     * @public
     */
    usePlaceholderImage: false,

    /**
     * The form factors.
     *
     * @public
     */
    formFactors: {
        portrait: {
            width:  2717,
            height: 3840
        },
        landscape: {
            width:  3840,
            height: 2160
        },
        square: {
            width:  2560,
            height: 2560
        }
    },

    /**
     * Get the width of the thumbnail for a specific form-factor.
     *
     * @param  {string}  formFactor  The form-factor
     * @return {number}  The width
     * @public
     */
    getWidth: function(formFactor) {
        return get(this.formFactors, formFactor + ".width", 1);
    },

    /**
     * Get the height of the thumbnail for a specific form-factor.
     *
     * @param  {string}  formFactor  The form-factor
     * @return {number}  The height
     * @public
     */
    getHeight: function(formFactor) {
        return get(this.formFactors, formFactor + ".height", 1);
    },

    /**
     * Get the aspect ratio of the thumbnail for a specific form-factor.
     *
     * @param  {string}  formFactor  The form-factor
     * @return {number}  The aspect ratio
     * @public
     */
    getAspectRatio: function(formFactor) {
        if (formFactor !== undefined && get(this.formFactors, formFactor, null)) {
            return this.getWidth(formFactor) / this.getHeight(formFactor);
        }
        else {
            return undefined;
        }
    },

    /**
     * Vertical padding of title in rem.
     *
     * @type {number}
     * @public
     */
    titlePaddingTb: 0.5,

    /**
     * Get the vertical padding of title in pixels.
     *
     * @return {number}  The padding in pixels
     * @public
     */
    getTitlePaddingTbPx: function() {
        return this.titlePaddingTb * themeVars.remToPx;
    },

    /**
     * The height of the title area in pixels
     *
     * @return {number}  The height in pixels
     * @public
     */
    getTitleHeightPx: function() {
        var padding    = this.getTitlePaddingTbPx(),
            lineHeight = themeVars.headerLineHeight * themeVars.remToPx;

        return padding + 2 * lineHeight * themeVars.fontSizeSmall + padding;
    },

    /**
     * Determines whether to show a delete icon based on media type.
     *
     * @param  {string}   mediaType  The media type
     * @return {boolean}  Whether to show a delete icon
     * @public
     */
    getDeleteIconVisibility: function(/* MediaType */) {
        return true;
    },

    /**
     * Determines whether to show a info link based on media type.
     *
     * @param  {string}   mediaType  The media type
     * @return {boolean}  Whether to show a info link
     * @public
     */
    getInfoLinkVisibility: function(mediaType) {
        return [
            "album_track", "audio", "book", "episode", "issue", "podcast_episode", "video"
        ].includes(mediaType);
    },

    /**
     * Determines whether to show a new ribbon based on media type.
     *
     * @param  {string}   mediaType  The media type
     * @return {boolean}  Whether to show a new ribbon
     * @public
     */
    getNewRibbonVisibility: function(/* MediaType */) {
        return true;
    },

    /**
     * Determines whether to show a plan ribbon based on media type.
     *
     * @param  {string}   mediaType  The media type
     * @param  {string}   plan       The plan
     * @return {boolean}  Whether to show a plan ribbon
     * @public
     */
    getPlanRibbonVisibility: function(mediaType, plan) {
        switch (plan) {
            case "ad_supported":
                return false;
            case "free":
                return false;
            case "premium":
                return true;
            default:
                return false;
        }
    },

    /**
     * Determines whether to show a play icon based on media type.
     *
     * @param  {string}   mediaType  The media type
     * @return {boolean}  Whether to show a play icon
     * @public
     */
    getPlayIconVisibility: function(/* MediaType */) {
        return false;
    },

    /**
     * Determines whether to show a quality stamp based on media type.
     *
     * @param  {string}   mediaType  The media type
     * @return {boolean}  Whether to show a quality stamp
     * @public
     */
    getQualityStampVisibility: function(/* MediaType */) {
        return true;
    }

};
